import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { createLogger } from 'redux-logger'
import thunkMiddleware, {ThunkMiddleware} from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import foundryApp from './reducers'
import {
  ocean,
  cheddar
} from '@vitalsource/vstui/colors';
import {
  createTheme,
  ThemeProvider
} from "@vitalsource/vstui/themes";
import { CookiesProvider } from 'react-cookie';
import Routes from "./Routes"
import {State} from "./reducers/index";
import LoadingContainer from './containers/LoadingContainer';
import GenericErrorContainer from './containers/GenericErrorContainer';
import {RecaptchaWindow} from "./types/Types";
import ReactGA from "react-ga";

const VITALSOURCE_BASEURL = "studio.vitalsource.com";
const GA_TRACKING_ID = "UA-113627382-1";


if (window.location.host !== VITALSOURCE_BASEURL) {
  ReactGA.initialize(GA_TRACKING_ID);
  ReactGA.pageview(window.location.pathname + window.location.hash);
}

const theme = createTheme({
  color: {
    primary: ocean,
    secondary: cheddar
  }
});

const loggerMiddleware = createLogger()

const store = createStore(
  foundryApp,
  applyMiddleware(
    thunkMiddleware as ThunkMiddleware<State, any>,
    loggerMiddleware
  )
)

class Foundry extends Component {
  render() {
    return (
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CookiesProvider>
              <LoadingContainer>
                <GenericErrorContainer>
                  <Routes />
                </GenericErrorContainer>
              </LoadingContainer>
            </CookiesProvider>
          </ThemeProvider>
        </Provider>
    )
  }
};

export default Foundry;
